export default "__VITE_ASSET__BMJw_dGo__"